import "../../App.scss";
import  "../../assets/css/libraries.css";
import  "../../assets/css/style.css";
import styled from "styled-components";

// New Added By Tapas
import "./Style.scss";

import {Helmet} from "react-helmet";



const IncentivesPlan = ({ type,setSearchText }) => {


    return (
        <div className="row">

            <div className="col-sm-12 col-md-12 col-lg-12">

                <section className="page-title page-title-layout5">
                    <div className="bg-img"><img src="assets/images/backgrounds/6.jpg" alt="background"/></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 scheme-content">
                                <div>
                                    <h3>Digital Health Incentive Scheme</h3>
                                    <p style={{marginBottom:'10px'}}>National Health Authority (NHA) intends to support different stakeholders of healthcare ecosystem like clinics, hospitals, and laboratories in adopting the Ayushman Bharat Digital Mission (ABDM) platform so as to make the benefits of digital health accessible for every section of the society.</p>
                                    <p>Although, there has been unprecedented growth in digital health records over the past few months, there is huge potential for further growth as healthcare continues to be offered non digitally on a significant scale. To further boost digital health transactions in the country, Mission Steering Group (MSG) in its meeting held on 31st August, 2022 directed NHA to bring a scheme for incentivization of different stakeholders of the health system. In the past as well, for promotion of other significant health initiatives like National Tuberculosis Elimination Program (NTEP) and Family Planning Program; incentivization schemes were implemented and were found to be very effective. This scheme would not only encourage health care providers to adopt digital health but would also motivate developers of digital health solutions such as Hospital/Health Management Information System (HMIS) and Laboratory Management Information System (LMIS) to make the quality solutions available at an affordable cost.</p>
                                    <h3 style={{marginTop:'15px'}}>Salient Points about the Incentive scheme</h3>
                                </div>
                                <ul id="l1">
                                    <li>
                                        <p>Incentives
                                            would be provided to the following players in the ecosystem:</p>
                                        <ul>
                                            <li data-list-text="•">
                                                <p>Health
                                                    Facilities having 10 or more beds as provided in the Health Facility
                                                    Registry</p>
                                            </li>
                                            <li data-list-text="•">
                                                <p>Laboratory/radiology
                                                    diagnostics centres or by whatever name called</p>
                                            </li>
                                            <li data-list-text="•">
                                                <p>Entities
                                                    providing ABDM enabled digital solutions (Digital Solution
                                                    Companies)</p>
                                            </li>
                                        </ul>
                                    </li>
                                    <li data-list-text="●">
                                        <p>Benefits
                                            will be provided to the health facilities only for transactions done by them
                                            above the base level of transactions (i.e. only the transactions above the
                                            threshold).</p>
                                        <p><br/></p>
                                        <table border={1} cellSpacing="0" style={{marginBottom:'15px'}}>
                                            <tr style={{height:'17pt'}}>
                                                <td>
                                                    <p className="table-heading">Healthcare Facility</p>
                                                </td>
                                                <td>
                                                    <p className="table-heading">Base
                                                        Level Criteria</p>
                                                </td>
                                                <td>
                                                    <p className="table-heading">Incentives</p>
                                                </td>
                                            </tr>
                                            <tr style={{height:'27pt'}}>
                                                <td>
                                                    <p className="s1">Hospitals</p>
                                                </td>
                                                <td>
                                                    <p className="s2">50
                                                        Transactions per bed per month</p>
                                                </td>
                                                <td>
                                                    <p className="s2">Rs <b>20 </b>per
                                                        additional transaction above the base level</p>
                                                </td>
                                            </tr>
                                            <tr style={{height:'26pt'}}>
                                                <td>
                                                    <p className="s1">Diagnostic
                                                        facilities</p>
                                                    <p className="s1">/Labs</p>
                                                </td>
                                                <td>
                                                    <p className="s2">500
                                                        Transactions per month</p>
                                                </td>
                                                <td>
                                                    <p className="s2">Rs <b>15 </b>per
                                                        additional transaction above the base level</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </li>
                                    <li data-list-text="●">
                                        <p>Digital
                                            Solution Companies (DSCs) will be provided an incentive of 25% of the
                                            incentive amount received by the eligible health facilities using their
                                            digital solutions.</p>
                                    </li>
                                    <li data-list-text="●">
                                        <p>For ABHA
                                            linked transactions done by facilities not eligible for direct incentives
                                            (Clinics/small hospitals/ health lockers/Teleconsultation platforms etc.),
                                            an incentive would be provided to Digital Solution Companies. It is expected
                                            that the benefits provided to the DSCs will help reduce the cost or will be
                                            further transferred to the concerned health facilities to cover their cost
                                            of digitization etc.</p>
                                        <p><br/></p>
                                        <table border={1} cellSpacing="0" style={{marginBottom:'15px'}}>
                                            <tr style={{height:'16pt'}}>
                                                <td colSpan="2">
                                                    <p className="table-heading">Cost
                                                        Incentives for Digital solution (HMIS and LMIS) Companies</p>
                                                </td>
                                            </tr>
                                            <tr  style={{height:'38pt'}}>
                                                <td>
                                                    <p className="s2">For
                                                        every Transaction by hospitals/labs using their software and
                                                        receiving incentives under this scheme</p>
                                                </td>
                                                <td>
                                                    <p className="s1">25% <span
                                                        className="s2">of the corresponding incentive amount received by the eligible facilities</span>
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr  style={{height:'37pt'}}>
                                                <td>
                                                    <p className="s2">For
                                                        other Transactions (including by health lockers,
                                                        Teleconsultation platforms, small clinics etc.), provided the
                                                        transactions are more than 200 per month</p>
                                                </td>
                                                <td>
                                                    <p className="s2">Rs <b>5 </b>per
                                                        Transaction</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </li>
                                    <li data-list-text="●">
                                        <p>NHA
                                            shall setup a mechanism to capture different type of transactions
                                            (stakeholder wise) and report the same on a publicly available benefits
                                            dashboard.</p>
                                    </li>
                                    <li data-list-text="●">
                                        <p>Total
                                            financial outlay for the scheme for next 6 months is Rs 50 crore.</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-12 d-flex justify-content-between flex-wrap align-items-center">
                                <div><img src="assets/images/abdm/dhis_info.jpg" alt="background1"/></div>
                            </div>
                        </div>
                    </div>
                </section>



                <Helmet>
                    <script src="../../assets/js/jquery-3.5.1.min.js"></script>
                    <script src="../../assets/js/plugins.js"></script>
                    <script src="../../assets/js/main.js"></script>
                    <script src=
                                "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"
                            type="text/javascript" />
                    <link rel="stylesheet"
                          href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"/>
                    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"/>

                    <link href="../../assets/images/logo/logo-light-small.png" rel="icon"/>
                </Helmet>
            </div>
        </div>
    );
};

const Card = styled.div`
background-color: white;
border: 2px solid #d5d5d5;
padding: 0.5rem;
border-radius: 10px;
flex-grow: 1;
flex-basis: 46%;
h6 {
  text-align: center;
  font-size: 1rem;
  margin-block: 3%;
}
ul {
  padding-left: 10%;
}
a {
  padding-left: 10%;
  color: #651fff !important;
}
`;

export default IncentivesPlan;
